<template>
  <div class=" flex items-center justify-center px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full py-12">
      <div>
        <h2
          class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
        >
          Register
        </h2>
      </div>

      <div>
        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form action="#" method="POST" @submit.prevent="onSubmit">
              <div>
                <label
                  for="email"
                  class="block text-sm font-medium leading-5 text-gray-700"
                >
                  Email address
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    v-model="email"
                    id="email"
                    type="email"
                    required
                    class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  />
                </div>
              </div>

              <div class="mt-6">
                <span class="block w-full rounded-md shadow-sm">
                  {{ vuebaseurl }}
                  <button
                    type="submit"
                    class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
                  >
                    Register
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "../utils/firebase";
const vuebaseurl = process.env.VUE_APP_BASE_URL;
export default {
  name: "Register",
  data() {
    return {
      email: "",
      vuebaseurl: vuebaseurl
    };
  },
  methods: {
    onSubmit() {
      // TODO: verification
      if (this.email.length < 3) {
        return;
      }
      const actionCodeSettings = {
        url: process.env.VUE_APP_BASE_URL + "/postLogin",
        handleCodeInApp: true
      };
      auth
        .sendSignInLinkToEmail(this.email, actionCodeSettings)
        .then(() => {
          window.localStorage.setItem("emailForSignIn", this.email);
        })
        .catch(err => console.error(err));
    }
  }
};
</script>

<style scoped></style>
